import React, { FC } from 'react';
import styles from './FacebookIcon.scss';

export const FacebookIcon: FC = () => <div className={styles.facebookIcon} />;
